module.exports = {
    name:      "sportbet_lobby",
    buildDate: "Mon Dec 09 2019 10:59:33 GMT+0000 (GMT)",
    version:   "1.0.0",
    build:     "244.2672 debug"
};



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 14
// module chunks = 0